import { render } from "./TrainingRncpAccordionSectorsComponent.vue?vue&type=template&id=c1562a30&scoped=true"
import script from "./TrainingRncpAccordionSectorsComponent.vue?vue&type=script&lang=js"
export * from "./TrainingRncpAccordionSectorsComponent.vue?vue&type=script&lang=js"

import "./TrainingRncpAccordionSectorsComponent.vue?vue&type=style&index=0&id=c1562a30&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1562a30"]])

export default __exports__